export default __webpack_public_path__ + "assets/venezuela-flag.png";